import { Color, Icons } from '@/app/core';
import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
    selector: 'c-button',
    templateUrl: './button.component.html',
    styleUrl: './button.component.css',
    standalone: false
})
export class ButtonComponent {
  @Input() texto = 'Ingresar texto';
  /** El icono del botón */
  @Input() icon!: Icons;
  /** Define la dirección del botón */
  @Input() alineamiento: 'izq' | 'der' | 'cen' = 'der';

  @Input() desactivado = false;

  @Input() color: Color = 'primary';
  
  @Input() alto: string = '';

  @Output() clickBtn = new EventEmitter<boolean>();

  @Input() rounded: boolean = false;
  @Input() primeIcon!: string;
  @Input() small = false;

  onClick() {
    this.clickBtn.emit(true);
  }
}
